'use client'
import JoinUs from '../driveChange/Join'
import { Testimonial_Team } from './testimonial_team'
// Team page deployed - Zeenat and Greig removed
const stats = [
  { label: 'Founded', value: '2023' },
  { label: 'Employees', value: '25' },
  { label: 'Countries', value: '3' },
  { label: 'Founder Exits', value: '13' },
]

const features = [
  {
    name: 'In-Person Support',
    description: '',
    imageSrc: '/dojo_4.jpg',
    imageAlt: 'In-Person dojo picture',
  },
  {
    name: 'Meetup Events',
    description: '',
    imageSrc: '/dojo_2.jpg',
    imageAlt: 'Meetup event with investors and fouders',
  },
  {
    name: 'Investor Events',
    description: '',
    imageSrc: '/dojo_3.jpg',
    imageAlt: 'investor events picture',
  },
  {
    name: 'Demo Days',
    description: '',
    imageSrc: '/dojo_1.jpg',
    imageAlt: 'demo day picture',
  },
]

const globals = [
  {
    name: 'Craig Massey',
    role: 'CEO',
    imageUrl: '/team/craig2.webp',
    twitterUrl: '',
    bio: "Craig Massey is an accomplished entrepreneur and the founder of AI Forge, where he helps startups build successful AI-based businesses. With experience launching nine startups, including five successful B2B SaaS platforms, Craig's most recent venture was a Blockchain Incubator that accounted for 24% of all UK blockchain investments in 2022. Prior to starting his own companies in the 90s, he held positions at major corporations like Polycell, Redland, and StenaLine.",
    linkedinUrl: 'https://www.linkedin.com/in/craig-massey/',
  },
  // {
  //   name: 'Robin Gounder',
  //   role: 'CTO',
  //   imageUrl: '/team/robin.webp',
  //   twitterUrl: 'https://twitter.com/Rob_GCC',
  //   bio: 'Robin empowers founders to transform ideas into pioneering AI solutions. As an award-winning expert in AI and blockchain, Robin founded Vaionex, a software company now valued at approximately $30 million. With deep expertise in AI technology, blockchain innovation, and product development, he leads the AI Forge AI and platform development.',
  //   linkedinUrl: 'https://www.linkedin.com/in/robin-gounder/',
  // },
  {
    name: 'Kevin Jackson',
    role: 'Chairman',
    imageUrl: '/team/kevin.webp',
    twitterUrl: '',
    bio: `With a career rooted in communication and business development, Kevin has held pivotal roles at renowned agencies like Saatchi Group, Grey Worldwide, Jack Morton Worldwide, and George P. Johnson. Known for his energetic, quick-thinking approach, Kevin has empowered both startups and corporations to achieve growth through personal and business development. He’s a seasoned international speaker, engaging audiences worldwide on the transformative potential of AI in today’s market.`,
    linkedinUrl: 'https://www.linkedin.com/in/kevinjacksonjmw/',
  },
]
const global = [
  {
    name: 'Craig Massey',
    role: 'Global CEO & Co-Founder',
    imageUrl: '/team/craig2.webp',
    twitterUrl: '',
    bio: "Craig Massey is an accomplished entrepreneur and the founder of AI Forge, where he helps startups build successful AI-based businesses. With experience launching nine startups, including five successful B2B SaaS platforms, Craig's most recent venture was a Blockchain Incubator that accounted for 24% of all UK blockchain investments in 2022. Prior to starting his own companies in the 90s, he held positions at major corporations like Polycell, Redland, and StenaLine.",
    expertise: 'Entrepreneurship, B2B SaaS Development, Blockchain Innovation',
    passion:
      'Providing tough love to founders to unlock their highest potential',
    linkedinUrl: 'https://www.linkedin.com/in/craig-massey/',
  },
  {
    name: 'Kevin Jackson',
    role: 'Chairman & Co-Founder',
    imageUrl: '/team/kevin.webp',
    twitterUrl: '',
    bio: 'With a career rooted in communication and business development, Kevin has held pivotal roles at renowned agencies like Saatchi Group, Grey Worldwide, Jack Morton Worldwide, and George P. Johnson. Known for his energetic, quick-thinking approach, Kevin has empowered both startups and corporations to achieve growth through personal and business development. He’s a seasoned international speaker, engaging audiences worldwide on the transformative potential of AI in today’s market.',
    expertise: 'Global Strategy, Brand Positioning, Industry Networking',
    passion:
      'Connecting ambitious founders with opportunities to disrupt the AI landscape.',
    linkedinUrl: 'https://www.linkedin.com/in/kevinjacksonjmw/',
  },
  // {
  //   name: 'Robin Gounder',
  //   role: 'Global CTO & Co-Founder',
  //   imageUrl: '/team/robin.webp',
  //   twitterUrl: 'https://twitter.com/Rob_GCC',
  //   bio: 'Robin empowers founders to transform ideas into pioneering AI solutions. As an award-winning expert in AI and blockchain, Robin founded Vaionex, a software company now valued at approximately $30 million. With deep expertise in AI technology, blockchain innovation, and product development, he leads Proof of Concept development for startups worldwide.',
  //   expertise: 'AI Technology, Blockchain Innovation, Product Development',
  //   passion:
  //     'Pushing technical boundaries helps founders turn visionary concepts into impactful, market-ready products.',
  //   linkedinUrl: 'https://www.linkedin.com/in/robin-gounder/',
  // },
  {
    name: 'Miguel Diaz',
    role: 'Global Programme Director & Co-Founder',
    imageUrl: '/team/miguel.webp',
    twitterUrl: '',
    bio: 'Miguel is a resourceful professional adept at swiftly interpreting information to develop strategic plans, implement processes, and make confident decisions. With extensive management consulting experience across Europe and the U.S., he specialises in project management, Agile IT development, logistics, operations, and marketing. Beyond his titles, Miguel is a dedicated problem-solver who drives change and empowers teams to achieve tangible results. At his core, he is a mentor and mediator, always ready to support and lead his team toward success.',
    expertise:
      'Programme Management, Operations Scaling, Healthcare Transformation',
    passion:
      'Crafting transformative journeys that challenge founders to excel.',
    linkedinUrl: 'https://www.linkedin.com/in/migueldiaz/',
  },
  {
    name: 'Steve Scruton',
    role: 'Chief Financial Officer',
    imageUrl: '/team/steve.webp',
    twitterUrl: '',
    bio: 'Steven is a venture consultant and investor with a background in mathematics, economics, and corporate governance. With 17 years of experience in financial analysis and strategic planning in the City, including as Head of Research, he is skilled at guiding ventures through complex growth phases. Known for his expertise in management accounting and industry insights, Steven has helped numerous founders achieve success through strategic guidance and financial acumen.',
    expertise: 'Financial Strategy, Venture Capital, Corporate Governance',
    passion:
      'Challenging startups to build robust financial models and achieve financial excellence.',
    linkedinUrl: 'https://www.linkedin.com/in/stephen-scruton-00a0a318/',
  },

  {
    name: 'Tim Seears',
    role: 'Entrepreneur in Residence',
    imageUrl: '/team/tim.webp',
    twitterUrl: '',
    bio: 'Tim brings his expertise as an entrepreneur and angel investor focused on mission-driven founders. Passionate about tackling global challenges like climate change, Tim actively invests in innovative companies across climate-tech, energy-tech, agtech, transport-tech, spacetech, AI, renewable energy, and the circular economy.',
    expertise:
      'Hands-on approach empowers startups aiming to create a sustainable impact.',
    passion:
      'Offering invaluable insights to founders working to make a meaningful difference in the world.',
    linkedinUrl: 'https://www.linkedin.com/in/tseears/',
  },
  {
    name: 'Mark Young',
    role: 'Outreach Manager',
    imageUrl: '/team/mark.webp',
    twitterUrl: '',
    bio: 'With over 30 years in tech, training, and media, Mark is committed to empowering businesses through AI innovation and transformative training. At AI Forge, he specialises in creating tailored AI training programs for founders, coaches, and consultants, making AI accessible and actionable.',
    expertise:
      'Helping teams simplify AI to automate processes, enhance client engagement, and build scalable content strategies that drive growth.',
    passion: 'An avid VR enthusiast - always up for a game of VR table tennis!',
    linkedinUrl: 'https://www.linkedin.com/in/markyoungsocial/',
  },
  {
    name: 'Cassio Dal Cortivo',
    role: 'Head of Programme',
    imageUrl: '/team/cassio.webp',
    twitterUrl: '',
    bio: 'Cassio is a multi-disciplinary entrepreneur with a diverse background in technology, marketing, and education. With experience launching and managing ventures in both Latin America and London, he is passionate about edtech and its transformative potential for learning.',
    expertise:
      'Leveraging emerging technologies—including AI, virtual reality, and blockchain.',
    passion: 'Bringing innovative perspectives to tech startups.',
    linkedinUrl: 'https://www.linkedin.com/in/cassiodal/',
  },

  {
    name: 'Tom Griffiths',
    role: 'Program Manager',
    imageUrl: '/team/tom.webp',
    twitterUrl: '',
    bio: 'Helping guide AI founders through the challenges of early-stage growth, leveraging hands-on mentorship, tailored workshops, and strategic insights to help startups build impactful, scalable businesses.',
    expertise: 'Community Building, Program Management',
    passion:
      'Empowering startups through their 12-week journey every step of the way',
    linkedinUrl: 'https://www.linkedin.com/in/grifft18/',
  },
]

const london = [
  {
    name: 'Gregory Dean',
    role: 'Investment Director',
    imageUrl: '/team/Greg.webp',
    twitterUrl: '',
    bio: 'Leveraging his expertise in fundraising and startup scaling to empower founders in the AI space. With a track record of raising over £300 million from Seed to Series A and scaling Cera to unicorn status and £200m+ revenue, Greg excels in fundraising strategy, investor relations, and growth acceleration.',
    expertise:
      'Helping founders navigate challenges to secure essential funding and drive success.',
    passion:
      'Connecting founders with elite investors and guiding them through rigorous fundraising challenges.',
    linkedinUrl: 'https://www.linkedin.com/in/dean2021/',
  },
  {
    name: 'Ethan Wang',
    role: 'Design Director',
    imageUrl: '/team/ethan-2.webp',
    twitterUrl: '',
    bio: 'With experience leading design for five cohorts at the Block Dojo incubator, Ethan specialises in UX/UI design for B2B SaaS platforms, focusing on user experience, interface design, and product branding. Passionate about crafting intuitive, high-engagement designs, Ethan helps startups elevate user experience, making their products more accessible, attractive, and effective in driving growth.',
    expertise: 'User Experience, Interface Design, Product Branding',
    passion:
      'Crafting intuitive designs that push startups to elevate their user engagement.',
    linkedinUrl: 'https://www.linkedin.com/in/ethan-whz/',
  },
]

export function Team() {
  return (
    <div className="bg-gradient-to-r from-[#060606] to-black">
      <div className="bg-black">
        <div className="relative isolate overflow-hidden bg-gradient-to-b from-indigo-900/20 pb-8">
          <div className="mx-auto max-w-7xl  pt-10 pb-24 sm:pb-32 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:py-40 lg:px-8 mb-20">
            <div className="px-6 lg:px-0">
              <div className="mx-auto max-w-7xl  ">
                <div className="max-w-7xl">
                  <div className="mt-5 sm:mt-20 lg:mt-8"></div>
                  <h1 className="mt-0 text-4xl font-bold tracking-tight text-gray-100 sm:text-5xl">
                    The Visionaries Driving AI Forge's Transformative Journey
                  </h1>
                  <p className="mt-6 text-lg leading-8 text-gray-300">
                    Pushing Boundaries to Shape Exceptional AI Innovators
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-20 sm:mt-24 md:mx-auto md:max-w-2xl lg:mx-0 lg:mt-0 lg:w-screen">
              <div
                className="absolute inset-y-0 right-1/2 -z-10 -mr-10 w-[200%] skew-x-[-30deg] bg-black shadow-xl shadow-indigo-600/10 ring-1 ring-black md:-mr-20 lg:-mr-36"
                aria-hidden="true"
              />
              <div className="shadow-lg md:rounded-3xl">
                <img
                  className="w-full scale-125"
                  src="./worldMap.webp"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-black sm:h-32" />
          <a
            href="#team-mission"
            className="arrow-container mx-auto  absolute bottom-8 left-1/2 transform -translate-x-1/2"
          >
            <div className="arrow"></div>
            <div className="arrow"></div>
            <div className="arrow"></div>
          </a>
        </div>
      </div>
      <div className="bg-black py-24 sm:py-32" id="team-mission">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 justify-end flex">
          <div className="mx-auto grid max-w-2xl grid-cols-1 items-start gap-y-16 gap-x-8 sm:gap-y-24 lg:mx-0  ">
            <div className="text-base leading-7 text-gray-200 w-full ">
              <p className="text-base font-semibold leading-7 text-blue-600">
                Company values
              </p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-100 sm:text-4xl">
                Meet the Team Behind AI Forge
              </h1>
              <div className="max-w-7xl">
                <p className="mt-6">
                  At AI Forge, our mission is to transform ambitious AI startups
                  into industry disruptors through rigorous challenges and elite
                  connections. Our team comprises seasoned entrepreneurs, AI
                  experts, and industry leaders who are passionate about pushing
                  boundaries and forging the next generation of AI leaders.
                </p>
              </div>
            </div>
            <dl className=" grid grid-cols-2 gap-8 border-t border-gray-200/10 pt-10 sm:grid-cols-4 lg:pl-28">
              {stats.map((stat, statIdx) => (
                <div key={statIdx}>
                  <dt className="text-sm font-semibold leading-6 text-blue-400">
                    {stat.label}
                  </dt>
                  <dd className="mt-2 text-3xl font-bold leading-10 tracking-tight text-gray-200">
                    {stat.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
      {/* <div className="mx-auto max-w-2xl py-24 px-4 sm:py-32 sm:px-0 lg:max-w-7xl lg:px-8">
        <div className="max-w-3xl">
          <h2 id="features-heading" className="font-medium text-gray-300">
            Our Background
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-100 sm:text-4xl">
            <span className="text-blue-500">We built </span>the UK&#8217;s #1
            Blockchain Incubator
          </p>
          <p className="mt-4 text-gray-300">
            This incubator accounted for 24% of all Blockchain investments in
            2022.
          </p>
          <p className="mt-4 text-gray-300">
            Block Dojo was officially launched on January 8th, 2022, as a
            dedicated blockchain incubator aimed at fostering innovation and
            nurturing promising startups in the field. Since its inception,
            Block Dojo has successfully initiated the growth of 33 cutting-edge
            companies, empowering them with the resources and mentorship
            necessary for their development and eventual success.
          </p>
          <p className="mt-4 text-gray-300">
            In February 2023, Block Dojo caught the attention of nChain, a
            leading global blockchain technology company, and was subsequently
            acquired. The strategic acquisition allowed us to expand our vision
            and support a new generation of AI startups through our recently
            established AI Forge incubator.
          </p>
          <p className="mt-4 text-gray-300">
            {' '}
            More at{' '}
            <a
              className="text-blue-400 pt-5"
              href="https://www.blockdojo.io"
              target="_blank"
            >
              www.blockdojo.io
            </a>
          </p>
        </div>

        <div className="mt-11 grid grid-cols-1 items-start gap-y-16 gap-x-6 sm:mt-16 sm:grid-cols-2 lg:grid-cols-4 lg:gap-x-8">
          {features.map((feature) => (
            <div key={feature.name} className="flex flex-col-reverse">
              <div className="mt-6">
                <h3 className="text-sm font-medium text-blue-400">
                  {feature.name}
                </h3>
                <p className="mt-2 text-sm text-gray-300">
                  {feature.description}
                </p>
              </div>
              <div className="aspect-w-1 aspect-h-1 overflow-hidden rounded-lg bg-gray-100">
                <img
                  src={feature.imageSrc}
                  alt={feature.imageAlt}
                  className="object-cover object-center"
                />
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <div className="bg-gradient-to-r bg-gray-900 bg-black pt-20 md:pt-28 pb-30 md:pb-30">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-y-20 gap-x-8 px-6 lg:px-8 xl:grid-cols-5">
          <div className="max-w-2xl xl:col-span-2">
            <h2 className="text-3xl font-bold tracking-tight text-gray-100 sm:text-4xl">
              Who We Are
            </h2>
            <p className="mt-6 text-lg leading-8 text-gray-400">
              We&apos;re a team of serial entrepreneurs driven to create
              real-world value through AI innovation. Our incubator, AI Forge,
              rapidly launches bold ideas and provides comprehensive support to
              startups, including world-class mentorship, funding, and
              resources. Our goal is to revolutionize the AI industry by
              empowering startups to develop game-changing solutions that tackle
              real-world challenges.
            </p>
            <div className="mt-6 max-w-2xl xl:col-span-2">
              <h2 className="text-3xl font-bold tracking-tight text-gray-100 sm:text-4xl">
                The London Team
              </h2>
              <p className="mt-6 text-lg leading-8 text-gray-400">
                Our London team is thrilled to be part of the dynamic tech
                ecosystem in the city, which is home to major industry leaders
                like Google, Amazon, and Facebook. With over £7.2 billion in
                venture capital invested in London startups in 2022 alone, the
                city is rapidly emerging as a hub for technology and innovation.
                Our presence in the UK capital not only bolsters our global
                expansion plans but also grants us convenient access to the
                thriving European AI market.
                <br />
                <br />
                Our team is dedicated to harnessing the favourable business
                environment and innovation-driven government in London to
                support entrepreneurs and startups in the region. We specialize
                in AI and machine learning, and are committed to providing our
                clients with powerful financial models to help them achieve
                success. With top universities nearby, a vibrant tech scene, and
                a collaborative community, London is the ideal location for our
                team to continue fostering innovation and growth in the AI
                industry.
              </p>
            </div>
          </div>
          <ul
            role="list"
            className="-mt-12 space-y-12 divide-y divide-gray-800 xl:col-span-3"
          >
            {[...global, ...london].map((person) => (
              <li
                key={person.name}
                className="flex flex-col gap-10 pt-12 sm:flex-row"
              >
                <img
                  className="aspect-[4/5] w-52 flex-none rounded-xl object-cover max-h-[18rem] "
                  src={person.imageUrl}
                  alt=""
                />
                <div className="max-w-xl flex-auto">
                  <h3 className="text-lg font-semibold leading-8 tracking-tight text-gray-200">
                    {person.name}
                  </h3>
                  <p className="text-base leading-7 text-blue-400">
                    {person.role}
                  </p>
                  <p className="mt-6 text-md leading-7 text-gray-100">
                    {person.bio}
                  </p>
                  <ul role="list" className="mt-6 flex gap-x-6">
                    {person.twitterUrl && (
                      <li>
                        <a
                          href={person.twitterUrl}
                          target="_blank"
                          className="text-gray-400 hover:text-gray-500"
                        >
                          <span className="sr-only">Twitter</span>
                          <svg
                            className="h-5 w-5"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                          </svg>
                        </a>
                      </li>
                    )}
                    <li>
                      <a
                        href={person.linkedinUrl}
                        target="_blank"
                        className="text-gray-400 hover:text-gray-500"
                      >
                        <span className="sr-only">LinkedIn</span>
                        <svg
                          className="h-5 w-5"
                          aria-hidden="true"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>

                  <p className="mt-8 text-md leading-7 text-gray-100">
                    Expertise : {person.expertise}
                  </p>
                  <p className="text-base leading-7 text-gray-100">
                    Passion : {person.passion}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {/* <div className="hidden bg-gradient-to-r bg-[#080707] bg-black py-24 md:py-32">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-y-20 gap-x-8 px-6 lg:px-8 xl:grid-cols-5">
          <ul
            role="list"
            className="-mt-12 space-y-12 divide-y divide-gray-800 xl:col-span-3"
          >
            {london.map((person) => (
              <li
                key={person.name}
                className="flex flex-col gap-10 pt-12 sm:flex-row items-start"
              >
                <img
                  className="aspect-[4/4] w-52 flex-none rounded-xl object-cover max-h-[18rem] "
                  src={person.imageUrl}
                  alt=""
                />
                <div className="max-w-xl flex-auto">
                  <h3 className="text-lg font-semibold leading-8 tracking-tight text-gray-200">
                    {person.name}
                  </h3>
                  <p className="text-base leading-7 text-blue-400">
                    {person.role}
                  </p>
                  <p className="mt-6 text-md leading-7 text-gray-100">
                    {person.bio}
                  </p>
                  <ul role="list" className="mt-6 flex gap-x-6">
                    {person.twitterUrl && (
                      <li>
                        <a
                          href={person.twitterUrl}
                          target="_blank"
                          className="text-gray-400 hover:text-gray-500"
                        >
                          <span className="sr-only">Twitter</span>
                          <svg
                            className="h-5 w-5"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                          </svg>
                        </a>
                      </li>
                    )}
                    <li>
                      <a
                        href={person.linkedinUrl}
                        target="_blank"
                        className="text-gray-400 hover:text-gray-500"
                      >
                        <span className="sr-only">LinkedIn</span>
                        <svg
                          className="h-5 w-5"
                          aria-hidden="true"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>

                  <p className="mt-8 text-md leading-7 text-gray-100">
                    Expertise : {person.expertise}
                  </p>
                  <p className="text-base leading-7 text-gray-100">
                    Passion : {person.passion}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="hidden bg-gradient-to-r bg-[#080707] bg-black py-24 md:py-32">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-y-20 gap-x-8 px-6 lg:px-8 xl:grid-cols-5">
          <div className="max-w-2xl xl:col-span-2">
            <h2 className="text-3xl font-bold tracking-tight text-gray-100 sm:text-4xl">
              The International Team
            </h2>
            <p className="mt-6 text-lg leading-8 text-gray-400">
              Our International team is excited to be a part of the thriving
              tech ecosystem in the city, which has attracted major players in
              the industry, including Spotify, Microsoft, and Apple. With more
              than $5.3 billion in venture capital being invested in Miami
              startups in 2022 alone, the city is quickly becoming a hub for
              technology and innovation. Our presence in South Florida not only
              supports our plans for global expansion but also provides us with
              easy access to a large and growing market for AI in Latin America.
              <br />
              <br />
              Our team is committed to leveraging the favourable business
              environment and innovation-friendly government of Miami to help
              entrepreneurs and startups in the area. We are experts in AI and
              machine learning and are dedicated to providing our clients with
              robust financial models to help them achieve success. With top
              universities in the area, a booming tech scene, and a supportive
              community, Miami is the perfect location for our team to continue
              driving innovation and growth in the AI industry.
            </p>
          </div>
          <ul
            role="list"
            className="-mt-12 space-y-12 divide-y divide-gray-800 xl:col-span-3"
          >
            {miami.map((person) => (
              <li
                key={person.name}
                className="flex flex-col gap-10 pt-12 sm:flex-row"
              >
                <img
                  className="aspect-[4/4] w-52 flex-none rounded-xl object-cover max-h-[18rem] "
                  src={person.imageUrl}
                  alt=""
                />
                <div className="max-w-xl flex-auto">
                  <h3 className="text-lg font-semibold leading-8 tracking-tight text-gray-200">
                    {person.name}
                  </h3>
                  <p className="text-base leading-7 text-blue-400">
                    {person.role}
                  </p>
                  <p className="mt-6 text-md leading-7 text-gray-100">
                    {person.bio}
                  </p>
                  <ul role="list" className="mt-6 flex gap-x-6">
                    {person.twitterUrl && (
                      <li>
                        <a
                          href={person.twitterUrl}
                          target="_blank"
                          className="text-gray-400 hover:text-gray-500"
                        >
                          <span className="sr-only">Twitter</span>
                          <svg
                            className="h-5 w-5"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                          </svg>
                        </a>
                      </li>
                    )}
                    {person.linkedinUrl && (
                      <li>
                        <a
                          href={person.linkedinUrl}
                          target="_blank"
                          className="text-gray-400 hover:text-gray-500"
                        >
                          <span className="sr-only">LinkedIn</span>
                          <svg
                            className="h-5 w-5"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="hidden bg-gradient-to-r bg-[#080707] bg-black py-24 md:py-32">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-y-20 gap-x-8 px-6 lg:px-8 xl:grid-cols-5">
          <div className="max-w-2xl xl:col-span-2">
            <h2 className="text-3xl font-bold tracking-tight text-gray-100 sm:text-4xl">
              The LATAM Team
            </h2>
            <p className="mt-6 text-lg leading-8 text-gray-400">
              Our Buenos Aires office is proud to serve as a gateway to the
              thriving tech ecosystem of Latin America, a region that has become
              a hotbed for tech innovation, with significant players like
              MercadoLibre ($60 billion), Nubank ($30 billion), Globant ($10
              billion), Kavak ($8.5 billion), Rappi ($5.1 billion) and
              TiendaNube ( billion) leading the charge. In recent years, Latin
              America has witnessed a surge in venture capital activity, with
              investments exceeding US$15 billion across the region in 2021.
              This investment boom underscores the region's rising prominence as
              a global center for technology and innovation. Establishing our
              base in Buenos Aires not only advances our strategy for global
              expansion but also positions us at the heart of the South American
              tech market.
              <br />
              <br />
              In this dynamic environment, we are eager to tap into the
              entrepreneurial energy and the innovation-oriented policies
              fostered by governments and the private sector across Latin
              America. Our Buenos Aires team specializes in AI and machine
              learning entrepreneurship, focusing on delivering sophisticated
              financial models to assist our startups in achieving their
              ambitions. Surrounded by top-tier universities, a vibrant
              technology scene, and a culture of collaboration, Buenos Aires is
              the ideal location from which to support innovation and growth in
              the AI industry throughout Latin America.
            </p>
          </div>
          <ul
            role="list"
            className="-mt-12 space-y-12 divide-y divide-gray-800 xl:col-span-3"
          >
            {latam.map((person) => (
              <li
                key={person.name}
                className="flex flex-col gap-10 pt-12 sm:flex-row"
              >
                <img
                  className="aspect-[4/4] w-52 flex-none rounded-xl object-cover max-h-[18rem] "
                  src={person.imageUrl}
                  alt=""
                />
                <div className="max-w-xl flex-auto">
                  <h3 className="text-lg font-semibold leading-8 tracking-tight text-gray-200">
                    {person.name}
                  </h3>
                  <p className="text-base leading-7 text-blue-400">
                    {person.role}
                  </p>
                  <p className="mt-6 text-md leading-7 text-gray-100">
                    {person.bio}
                  </p>
                  <ul role="list" className="mt-6 flex gap-x-6">
                    {person.twitterUrl && (
                      <li>
                        <a
                          href={person.twitterUrl}
                          target="_blank"
                          className="text-gray-400 hover:text-gray-500"
                        >
                          <span className="sr-only">Twitter</span>
                          <svg
                            className="h-5 w-5"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                          </svg>
                        </a>
                      </li>
                    )}
                    {person.linkedinUrl && (
                      <li>
                        <a
                          href={person.linkedinUrl}
                          target="_blank"
                          className="text-gray-400 hover:text-gray-500"
                        >
                          <span className="sr-only">LinkedIn</span>
                          <svg
                            className="h-5 w-5"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div> */}
      <Testimonial_Team />

      <div className="bg-black mb-20">
        <JoinUs />
      </div>
    </div>
  )
}
